// extracted by mini-css-extract-plugin
module.exports = {"container":"Retailers_container__RTWKG","head":"Retailers_head__UiUiv","retailersWrapper":"Retailers_retailersWrapper__Gn9vg"};